import { SvgIcon, SvgIconProps } from "@mui/material";

function LockCloudSvgIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 20V10H16.5V10.814C17.2117 10.8639 17.8864 11.0461 18.5 11.3361V10C18.5 8.9 17.6 8 16.5 8H15.5V6C15.5 3.24 13.26 1 10.5 1C7.74 1 5.5 3.24 5.5 6V8H4.5C3.4 8 2.5 8.9 2.5 10V20C2.5 21.1 3.4 22 4.5 22H10.976C10.1038 21.5545 9.38235 20.8553 8.90922 20H4.5ZM7.5 6C7.5 4.34 8.84 3 10.5 3C12.16 3 13.5 4.34 13.5 6V8H7.5V6Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5704 14.2938C13.2919 13.1002 14.6026 12.3 16.1 12.3C17.9767 12.3 19.5578 13.5515 20.0572 15.2698C21.3917 15.5346 22.4 16.7011 22.4 18.1167C22.4 19.7268 21.0935 21.0333 19.4833 21.0333H13.2C11.324 21.0333 9.8 19.5093 9.8 17.6333C9.8 15.9729 10.992 14.5877 12.5704 14.2938ZM18.2147 16.0052C18.0146 14.9965 17.1271 14.2667 16.1 14.2667C15.2928 14.2667 14.5639 14.7121 14.1899 15.4325L14.1893 15.4338L13.8222 16.1313L13.0385 16.2119C12.3152 16.2869 11.7667 16.896 11.7667 17.6333C11.7667 18.4254 12.408 19.0667 13.2 19.0667H19.4833C20.0047 19.0667 20.4333 18.638 20.4333 18.1167C20.4333 17.6306 20.0479 17.2164 19.5577 17.185L19.5557 17.1849L18.4345 17.1042L18.2147 16.0052Z"
        fill={props.color}
      />
    </SvgIcon>
  );
}

LockCloudSvgIcon.muiName = "LockCloudSvgIcon";

export default LockCloudSvgIcon;
